import { useQuery } from '@tanstack/react-query';

import { useFleet } from '../hooks/useFleet';
import { InsightService } from '../services';

export interface TopLocationEntry {
  block_name: string;
  count: number;
  route_direction: string;
}

export interface TopLocationsPerViolation {
  event_type_id: number;
  data: TopLocationEntry[];
}

interface UseDailyEventsChartParams {
  startDate: string;
  endDate: string;
}

interface UseTopLocationsParams {
  startDate: string;
  endDate: string;
  eventTypeIds: number[];
}

export const useDailyEventsChart = (params: UseDailyEventsChartParams) => {
  const fleet = useFleet();
  const { startDate, endDate } = params;
  const queryKey = ['charts', 'dailyEvents', fleet.uuid, startDate, endDate];

  const queryFn = () => {
    return InsightService.getEvidencesDeliveredByMonth({
      startDate,
      endDate,
    });
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.uuid,
  });
};

export const usePaidCitationsChart = (params: UseDailyEventsChartParams) => {
  const fleet = useFleet();
  const { startDate, endDate } = params;
  const queryKey = ['charts', 'paidCitations', fleet.uuid, startDate, endDate];

  const queryFn = () => {
    return InsightService.getCitationsPaidByMonth({
      startDate,
      endDate,
    });
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.uuid,
  });
};

export const useTopLocationsChart = (params: UseTopLocationsParams) => {
  const fleet = useFleet();
  const { startDate, endDate, eventTypeIds } = params;
  const queryKey = ['charts', 'topLocations', fleet.uuid, startDate, endDate, eventTypeIds];

  const queryFn = () => {
    return InsightService.getTopLocations({
      startDate,
      endDate,
      eventTypeIds,
    });
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.uuid,
  });
};
